import {
  AssignPropertyToGeneralDocumentData,
  FormSubmitHandlerProps,
} from "./types";
import { FormikValues } from "formik";
import { HTTP_STATUS_CODES } from "../../../../types/server";
import { mapBackendValidationErrors } from "../../../../utils/form";
import { SOMETHING_WENT_WRONG_ERROR } from "../../../../constants";
import { assignPropertyToGeneralDocument } from "../../../../api/generalDocuments";

export const assignPropertyInitialValues: AssignPropertyToGeneralDocumentData =
  {
    property_id: null,
  };
/* istanbul ignore next */
export const handleAssignProperty = (
  id: string,
  { setFormMessage, afterAssignProperty }: FormSubmitHandlerProps
) => {
  return async (
    values: AssignPropertyToGeneralDocumentData,
    { setStatus, setSubmitting }: FormikValues
  ): Promise<void> => {
    const response = await assignPropertyToGeneralDocument(+id, values);
    const json = await response.json();

    if (
      [HTTP_STATUS_CODES.OK, HTTP_STATUS_CODES.CREATED].includes(
        response.status
      )
    ) {
      setStatus({
        success: true,
        errors: {},
      });
      afterAssignProperty && afterAssignProperty();
    } else if (response.status === HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY) {
      setStatus({
        success: false,
        errors: mapBackendValidationErrors(json.errors),
      });
    } else {
      setFormMessage({ type: "error", text: SOMETHING_WENT_WRONG_ERROR });
    }
    setSubmitting(false);
  };
};
